<template>
  <div class="main">
    <header
      v-if="!$route.meta.hidOther"
      :class="{ 'services-header': $route.path.startsWith('/services') }"
    >
      <div :class="{ content: true, services: $route.path.startsWith('/services') }">
        <div class="logo-container">
          <router-link to="/">
            <img class="logo-img" :src="require('@/assets/images/logo.png')" alt="Logo" />
            <span class="logo-text">Glacix</span>
          </router-link>
        </div>
        <ul class="nav" @blur="showNav = false" :style="showNav && 'left: 0; opacity: 1;'">
          <li :class="{ current: isProductsActive, 'products-expanded': showProductsMenu }">
            <router-link
              to="/services/acquiring"
              :class="{ rotate: showProductsMenu }"
              @click.native="handleProductsNavClick"
            >
              {{ $t('layout.nav.products') }}
              <i class="nav-chevron" />
            </router-link>
            <ul class="dropdown" :class="{ open: showProductsMenu }">
              <p>{{ $t('layout.nav.products') }}</p>
              <li v-for="(item, index) in productMenu" :key="item.title">
                <router-link :to="productLinks[index]">
                  <img :src="startIcons[index]">
                  <div>
                    <span>{{ item.title }}</span>
                    <p>{{ item.desc }}</p>
                  </div>
                </router-link>
              </li>
            </ul>
          </li>
          <li :class="{ current: current === '' }">
            <router-link to="/compliance">{{ $t('layout.nav.compliance') }}</router-link>
          </li>
          <li :class="{ current: current === '' }">
            <router-link to="/about">{{ $t('layout.nav.about') }}</router-link>
          </li>
          <li>
            <a href="https://docs.glacix.com/Help/" target="_blank">{{ $t('layout.nav.help') }}</a>
          </li>
          <li class="nav-auth">
            <a
              class="nav-auth-login"
              :href="`${clientUrl}/auth/login`"
              target="_blank"
              @click="showNav = false"
            >{{ $t('common.login') }}</a>
            <a
              class="nav-auth-register"
              :href="`${clientUrl}/auth/register`"
              target="_blank"
              @click="showNav = false"
            >{{ $t('common.register') }}</a>
          </li>
        </ul>
        <div class="action">
          <a class="button" :href="`${this.clientUrl}/auth/login`" target="_blank">
            <span>{{ $t('common.login') }}</span>
            <div class="arrowBox">
              <span class="arrow">
                <i /><i /><i />
              </span>
            </div>
          </a>
          <a class="button" :href="`${this.clientUrl}/auth/register`" target="_blank">{{ $t('common.register') }}</a>
        </div>
        <div class="locale-switcher">
          <button
            v-for="locale in locales"
            :key="locale"
            type="button"
            :class="{ active: $i18n.locale === locale }"
            @click="switchLocale(locale)"
          >
            <span>{{ locale === 'zh-CN' ? $t('common.languageZh') : $t('common.languageEn') }}</span>
          </button>
        </div>
        <a :class="`list ${showNav && 'open'}`" @click="showNav = !showNav">
          <i /><i /><i />
        </a>
        <a class="client" :href="`${this.clientUrl}/auth/login`" target="_blank">
          <img src="@/assets/images/client.png" alt="Client" />
        </a>
        <a class="masking" :style="`display: ${showNav ? 'block' : 'none'};`" @click="showNav = false" />
      </div>
    </header>
    <router-view />
    <div v-if="!$route.meta.hidOther" class="contact">
      <GradientAnimation :height="'100%'" :skewY="0" :bottom="0"/>
      <div class="content">
        <p>{{ contactHeading }}</p>
        <h5>{{ $t('layout.contactSubheading') }}</h5>
        <div class="action">
          <a class="button" :href="`${this.clientUrl}/auth/register`">
            <span>{{ $t('common.registerNow') }}</span>
            <div class="arrowBox">
              <span class="arrow">
                <i /><i /><i />
              </span>
            </div>
          </a>
          <router-link class="button" to="/customer" target="_blank">
            <span>{{ $t('common.contactUs') }}</span>
            <div class="arrowBox">
              <span class="arrow">
                <i /><i /><i />
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <footer v-if="!$route.meta.hidOther">
      <div class="content">
        <div class="list">
          <div>
            <!-- <img src="@/assets/images/logo-footer.png" alt="Logo" /> -->
            <div class="logo-container">
            <img class="logo-img" src="@/assets/images/logo.png" alt="Logo" />
            <span class="logo-text">Glacix</span>
            </div>
            <span>{{ $t('common.copyright') }}</span>
          </div>
          <ul>
            <li>
              <a>{{ $t('layout.footer.products') }}</a>
            </li>
            <li>
              <router-link to="/services/acquiring">{{ productMenu[0].title }}</router-link>
            </li>
            <li>
              <router-link to="/services/collection">{{ productMenu[1].title }}</router-link>
            </li>
            <li>
              <router-link to="/services/exchange">{{ productMenu[2].title }}</router-link>
            </li>
            <li>
              <router-link to="/services/payment">{{ productMenu[3].title }}</router-link>
            </li>
          </ul>
          <ul>
            <li>
              <a>{{ $t('layout.footer.legal') }}</a>
            </li>
            <li>
              <a href="https://docs.glacix.com/Law/" target="_blank">{{ $t('layout.footer.disclaimer') }}</a>
            </li>
            <li>
              <a href="https://docs.glacix.com/Law/PrivacyPolicy/" target="_blank">{{ $t('layout.footer.privacy') }}</a>
            </li>
            <li>
              <a href="https://docs.glacix.com/Law/FraudAwareness/" target="_blank">{{ $t('layout.footer.fraud') }}</a>
            </li>
          </ul>
          <ul>
            <li>
              <a>{{ $t('layout.footer.support') }}</a>
            </li>
            <li>
              <router-link to="/about">{{ $t('layout.footer.company') }}</router-link>
            </li>
            <li>
              <router-link to="/customer" target="_blank">{{ $t('layout.footer.contact') }}</router-link>
            </li>
          </ul>
        </div>

        <div style="display: none;">
          <div class="contactUs">
            <span>{{ $t('layout.footer.contactPhoneLabel') }}</span>
            <p>0755-8654-9155</p>
          </div>
          <div class="divider"></div>
          <div class="address">
            <span>{{ $t('layout.footer.shenzhenAddress') }}</span>
            <span>{{ $t('layout.footer.hongKongAddress') }}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import GradientAnimation from '@/components/GradientAnimation'
  import { LOCALES, applyDocumentLocale, persistLocale } from '@/i18n'
  export default {
    name: 'Main',
    data() {
      return {
        current: this.$route.name,
        showNav: false,
        showProductsMenu: false,
        locales: [LOCALES.ZH_CN, LOCALES.EN_US],
        startIcons: [
          require('@/assets/images/Home/start-1.png'),
          require('@/assets/images/Home/start-2.png'),
          require('@/assets/images/Home/start-3.png'),
          require('@/assets/images/Home/start-4.png'),
        ],
        productLinks: [
          '/services/acquiring',
          '/services/collection',
          '/services/exchange',
          '/services/payment',
        ],
      };
    },
    components: {
      GradientAnimation,
    },
    computed: {
      productMenu() {
        return this.$t('layout.productMenu');
      },
      isProductsActive() {
        return this.productLinks.includes(this.$route.path);
      },
      contactHeading() {
        const headings = this.$t('layout.contactHeading');
        return headings[this.$route.name] || headings.default;
      },
    },
    methods: {
      switchLocale(locale) {
        if (this.$i18n.locale === locale) return;
        this.$i18n.locale = locale;
        applyDocumentLocale(locale);
        persistLocale(locale);
        this.updateDocumentTitle(this.$route);
      },
      updateDocumentTitle(route) {
        const title = route.meta.titleKey ? this.$t(route.meta.titleKey) : this.$t('meta.siteName');
        document.title = route.name === 'Home' ? title : `${title} - ${this.$t('meta.siteName')}`;
      },
      handleProductsNavClick(event) {
        if (window.innerWidth > 1000) return;
        event.preventDefault();
        this.showProductsMenu = !this.showProductsMenu;
      },
    },
    watch: {
      showNav(value) {
        if (!value) this.showProductsMenu = false;
      },
      $route(to) {
        this.current = to.name;
        this.showNav = false;
        this.showProductsMenu = false;
      },
      '$i18n.locale'() {
        this.updateDocumentTitle(this.$route);
      },
    },
  };
</script>

<style lang="less">
.bodyFont(@bodyFontSize: 18px, @bodyLineHeight: 1.555555556, @fontWeightNormal: 300) {
  font: @fontWeightNormal @bodyFontSize/@bodyLineHeight "sohne-var","Helvetica Neue","Arial",sans-serif;
}

.logo-container {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;

  a {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }
}

.logo-img {
  margin-right: 10px;
  width: 50px !important; 
  vertical-align: middle;
}

.logo-text {
  font-weight: bold;
  color: #fff;
  font-size: 24px;
  vertical-align: middle;
  letter-spacing: 0.05em;
}

.locale-switcher {
  display: inline-flex;
  align-items: center;
  display: flex;
  margin-left: 16px;
  padding: 4px;
  background: rgba(10, 37, 64, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  box-shadow: 0 12px 30px rgba(10, 37, 64, 0.14);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  button {
    min-width: 44px;
    height: 34px;
    padding: 0 12px;
    color: rgba(255, 255, 255, 0.92);
    background: transparent;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition: background-color 180ms ease, color 180ms ease, box-shadow 180ms ease;

    span {
      display: block;
      font-size: 13px;
      font-weight: 600;
      line-height: 1;
      letter-spacing: 0.02em;
    }

    &:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.12);
    }
  }

  .active {
    color: #0A2540;
    background: #FFFFFF;
    box-shadow: 0 6px 18px rgba(10, 37, 64, 0.18);
  }
}

.main {

  img {
    display: block;
    -webkit-user-drag: none;
  }

  p {
    & > span {
      font-weight: 400;
    }
  }
  header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;

    &.services-header {
      background-color: #FFFFFF;
      border-bottom: 1px solid #E0E6F7;
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      transition: all 200ms;

      .logo {
        width: 220px;

        &:last-child {
          display: none;
        }
      }

      .nav {
        height: 100%;
        margin-bottom: 0;
        padding-left: 60px;

        & > li {
          position: relative;
          float: left;
          height: 100%;
          display: flex;
          align-items: center;
          margin: 0 25px;
          cursor: pointer;
          overflow: hidden;

          &:before {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 0;
            content: '';
            background: #0070FF;
            transition: all 300ms;
          }

          & > a {
            height: 100%;
            display: flex;
            align-items: center;
            color: white;
            font-weight: 400;
            transition: all 300ms;
            line-height: 24px;

            .fas {
              position: relative;
              top: 1px;
              margin-left: 3px;
            }
          }

          .dropdown {
            position: absolute;
            top: 80px;
            left: -100px;
            padding: 39px 16px 31px 16px;
            width: 280px;
            background-color: white;
            box-shadow: 0 15px 35px 10px rgba(0,0,0,0.12);
            border-radius: 8px;
            opacity: 0;
            transform: scaleY(0.8);
            transform-origin: top;
            transition: all 300ms;

            & > p {
              font-size: 14px;
              color: #8898AA;
              margin-left: 16px;
              margin-bottom: 18px;
            }

            & > li {
              padding: 9px 16px;
              border-radius: 8px;
              margin-bottom: 12px;
              & > a {
                display: flex;
                align-items: center;
                & > img {
                  width: 32px;
                  margin-right: 15px;
                }
                & > div {
                  & > span {
                    font-size: 14px;
                    color: #001A36;
                    line-height: 20px;
                  }
                  & > p {
                    font-size: 12px;
                    color: #001A36;
                    opacity: 0.6;
                    margin-top: 4px;
                    line-height: 18px;
                  }
                }
              }
              &:hover {
                background-color: rgba(220,220,220,0.3);
              }
              &:last-child {
                margin-bottom: 0;
              }
            }
          }

          &:hover {
            overflow: initial;

            & > a {
              opacity: 0.7;
            }

            .dropdown {
              opacity: 1;
              transform: scaleY(1);
            }
          }
        }

        .current {
          &:before {
            height: 4px;
          }

          & > a {
            color: #0070FF;
          }
        }
      }

      .action {
        display: flex;

        .button {
          margin-left: 10px;
          font-weight: 400;
          background: rgba(255,255,255,0.2);
          height: auto;
          padding: 3px 0;
          .bodyFont(15px, 1.6, 425);

          &:last-child {
            width: 76px;
            background: #0070FF;
          }

          &:hover {
            background: rgba(255,255,255,0.4);

            &:last-child {
              background: #0A2540;
            }
          }
        }
      }

      .list,
      .client {
        display: none;
      }

      .nav-chevron {
        display: none;
      }

      .nav > li.nav-auth {
        display: none;
      }
    }

    .content:not(.services) {
      .list {
        background: transparent;
      }
    }

    .services {
      .logo {
        &:first-child {
          display: none;
        }

        &:last-child {
          display: block;
        }
      }

      .logo-text {
        color: #082440;
      }

      .nav > li > a {
        color: #32325D;
      }

      .action .button {
        margin-left: 10px;
        color: #32325D;
        background: rgba(234, 234, 238, 0.4);

        .arrow > i {
          background: #32325D;
        }

        &:last-child {
          color: white;
        }

        &:hover {
          background: rgba(234, 234, 238, 0.8);
        }
      }

      .locale-switcher {
        background: rgba(255, 255, 255, 0.88);
        border-color: rgba(130, 152, 180, 0.35);
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);

        button {
          color: #52627A;

          &:hover {
            color: #0A2540;
            background: rgba(10, 37, 64, 0.06);
          }
        }

        .active {
          color: #FFFFFF;
          background: #0A2540;
          box-shadow: 0 8px 16px rgba(10, 37, 64, 0.16);
        }
      }

      .list {
        background: transparent;

        & > i {
          background: #0070FF;
        }
      }
    }
  }

  .contact {
    position: relative;
    z-index: 2;

    .content {
      padding: 60px 0;

      & > p {
        margin-bottom: 12px;
        color: white;
        font-size: 20px;
        font-weight: 400;
        line-height: 29px;
      }

      & > h5 {
        margin-bottom: 30px;
        color: white;
        font-size: 40px;
        font-weight: 400;
        line-height: 59px;
      }

      .action {
        display: flex;
        justify-content: flex-end;

        .button {
          width: 122px;
          margin-left: 20px;
          background: #0070FF;
          cursor: pointer;
          &:first-child:hover {
            background: #0A2540;
          }

          &:last-child {
            color: #3C3A97;
            background: white;

            .arrow > i {
              background: #3C3A97;
            }
          }
        }
      }
    }
  }

  footer {
    position: relative;
    background: #15192C;

    .content {
      padding: 60px 0 20px;

      .list {
        display: flex;
        justify-content: space-between;
        margin-bottom: 80px;
        & > div {
          /*flex-grow: 1;*/

          & > img {
            width: 248px;
            margin-bottom: 20px;
          }

          & > span {
            display: block;
            color: #989898;
          }
        }

        & > ul {
          width: 180px;

          &:last-child {
            width: 165px;
          }

          & > li {
            cursor: pointer;
            margin-bottom: 16px;
            font-weight: 400;
            font-size: 14px;
            & > a {
              color: #a8b4bf;
              &:hover {
                color: #FFFFFF;
              }
            }
            &:first-child {
              & > a {
                color: #FFFFFF;
                cursor: default;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .contactUs {
        margin: 120px 0 0 0;
        & > span {
          font-size: 14px;
        }
        & > p {
          font-size: 14px;
        }
      }

      .divider {
        margin: 25px 0 20px;
        height: 1px;
        background: #979797;
      }
    }

    .address {
      color: white;
      font-size: 12px;

      & > span:first-child {
        margin-right: 60px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .main {
    padding-top: 44px;

    header {
      background-color: #FFFFFF;
      border-bottom: 1px solid #E0E6F7;

      .logo-text {
        color: #082440;
      }

      .locale-switcher {
        background: rgba(255, 255, 255, 0.88);
        border-color: rgba(130, 152, 180, 0.35);
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
        backdrop-filter: none;
        -webkit-backdrop-filter: none;

        button {
          color: #52627A;

          &:hover {
            color: #0A2540;
            background: rgba(10, 37, 64, 0.06);
          }
        }

        .active {
          color: #FFFFFF;
          background: #0A2540;
          box-shadow: 0 8px 16px rgba(10, 37, 64, 0.16);
        }
      }

      .content {
        height: 44px;
        justify-content: center;

        & > a {
          line-height: 0;

          .logo {
            height: 18px;
          }
        }

        .nav {
          position: fixed;
          left: -150px;
          top: 44px;
          display: flex;
          flex-direction: column;
          width: 150px;
          height: calc(100% - 44px);
          padding-left: 0;
          background-color: white;
          box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.15);
          transition: all 300ms;
          opacity: 0;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;

          & > li {
            position: relative;
            float: none;
            flex: 0 0 auto;
            flex-direction: column;
            align-items: stretch;
            width: 100%;
            height: auto;
            margin: 0;
            padding: 0;
            overflow: visible;
            border-bottom: 1px solid #EEF1F6;

            &:before {
              display: none;
            }

            & > a {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: 48px;
              padding: 0 20px;
              color: #082440;
              font-size: 15px;
              font-weight: 500;

              .nav-chevron {
                display: block;
                flex-shrink: 0;
                width: 0;
                height: 0;
                margin-left: 8px;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 6px solid currentColor;
                opacity: 0.7;
                transition: transform 300ms;
              }
            }

            & > a.rotate .nav-chevron {
              transform: rotate(180deg);
            }

            &.products-expanded {
              z-index: 2;
            }

            .dropdown {
              position: relative;
              top: 0;
              left: 0;
              width: 100%;
              max-height: 0;
              padding: 0;
              box-shadow: none;
              border-radius: 0;
              opacity: 1;
              transform: none;
              overflow: hidden;
              background: #F7F9FC;
              transition: max-height 280ms ease;
              list-style: none;

              & > p {
                display: none;
              }

              & > li {
                margin: 0;

                & > a {
                  display: flex;
                  align-items: center;
                  width: 100%;
                  height: auto;
                  min-height: 0;
                  padding: 6px 16px 6px 28px;
                  color: #52627A;

                  & > img {
                    display: none;
                  }

                  & > div {
                    min-width: 0;

                    & > span {
                      display: block;
                      font-size: 13px;
                      font-weight: 400;
                      line-height: 20px;
                    }

                    & > p {
                      display: none;
                      margin: 0;
                    }
                  }
                }
              }

              &.open {
                max-height: 240px;
                padding-bottom: 8px;
              }
            }

            &:hover > a {
              color: #151827;
            }
          }

          .current {
            & > a {
              color: #0070FF !important;
            }
          }

          & > li.nav-auth {
            display: flex;
            flex-direction: row;
            gap: 12px;
            margin-top: auto;
            padding: 20px 16px 24px;
            border-bottom: none;
            background: #FFFFFF;
            margin-bottom: 16px;

            & > a {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              width: auto;
              height: 44px;
              min-height: 44px;
              padding: 0 12px;
              font-size: 15px;
              font-weight: 500;
              line-height: 1;
              border-radius: 22px;
              white-space: nowrap;
            }

            .nav-auth-login {
              color: #082440;
              background: #FFFFFF;
              border: 1px solid #D0D9E6;

              &:active {
                background: #F7F9FC;
              }
            }

            .nav-auth-register {
              color: #FFFFFF;
              background: #0070FF;
              border: none;

              &:active {
                background: #0A2540;
              }
            }
          }
        }

        .action {
          display: none;
        }

        .locale-switcher {
          position: absolute;
          right: 46px;
          top: 50%;
          margin-left: 0;
          transform: translateY(-50%) scale(0.9);
          transform-origin: right center;
        }

        .list,
        .client {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 44px;
          height: 100%;
        }

        .list > i {
          display: block;
          width: 19.5px;
          height: 2px;
          margin-bottom: 5px;
          background: #0070FF;
          border-radius: 1px;
          transition: all 300ms;

          &:first-child,
          &:last-child {
            transform-origin: left;
          }

          .open > i:nth-child(2) {
            transform-origin: 50%;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }

        .open > i:first-child {
          transform: rotate(45deg);
        }

        .open > i:nth-child(2) {
          transform: scale(0);
        }

        .open > i:last-child {
          transform: rotate(-45deg);
        }

        .client {
          left: auto;
          right: 0;
          padding-bottom: 2px;

          & > img {
            width: 22px;
          }
        }

        .masking {
          position: fixed;
          top: 44px;
          right: 0;
          width: calc(100% - 150px);
          height: calc(100% - 44px);
        }
      }
    }

    .contact {
      .content {
        padding-left: 20px;
        padding-right: 20px;
      }
    }

    footer {
      .content {
        padding: 26px 20px 20px;

        .list {
          flex-direction: column;

          & > div {
            margin-bottom: 40px;

            & > img {
              height: 21px;
              margin-bottom: 8px;
            }
          }

          & > ul {
            width: auto;
            margin-bottom: 40px;

            &:last-child {
              width: auto;
            }
          }
        }

        .divider {
          margin: 0 0 20px;
          height: 1px;
          background: #979797;
        }
      }

      .address {
        display: flex;
        flex-direction: column;

        & > span:first-child {
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
    }

    .fixed .content {
      height: 44px !important;

      .nav {
        background-color: rgba(255,255,255,0.8) !important;

        .dropdown {
          top: 0 !important;
          background-color: transparent !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .main {
    padding-top: 68px;

    header {
      .content {
        height: 68px;
        padding: 0 16px;
        justify-content: center;

        .logo-container {
          transform: none;
          margin-left: 18px;

          .logo-img {
            width: 40px !important;
            margin-right: 8px;
          }

          .logo-text {
            font-size: 18px;
          }
        }

        .locale-switcher {
          position: absolute;
          right: 14px;
          top: 50%;
          padding: 2px;
          margin-left: 0;
          transform: translateY(-50%);

          button {
            min-width: 34px;
            height: 26px;
            padding: 0 7px;

            span {
              font-size: 12px;
            }
          }
        }

        .nav {
          top: 68px;
          width: 78vw;
          max-width: 280px;
          left: -280px;
          padding-left: 0;
        }

        .masking {
          top: 68px;
          left: 280px;
          width: calc(100% - 280px);
        }

        .action,
        .client {
          display: none;
        }

        .list {
          left: 16px;
          top: 0;
          height: 68px;

          & > i {
            background: #5BA3FF;
          }
        }
      }
    }

    .contact {
      .content {
        padding: 40px 16px;

        & > p {
          font-size: 18px;
          line-height: 28px;
        }

        & > h5 {
          font-size: 28px;
          line-height: 40px;
        }

        .action {
          flex-direction: column;
          align-items: stretch;

          .button {
            width: 100%;
            margin: 0 0 14px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
